<template>
  <header
    id="site-header"
    class="relative site-header"
    :class="[{ open: isOpen }, { home: isHome }, { 'vehicles-open': vehiclesOpen }]"
  >
    <div class="flex justify-between content-max-width content-nav">
      <a href="/" class="logo">
        <img src="/images/logo.svg" :alt="data.site_name" />
      </a>
      <nav>
        <ul class="top sub-nav">
          <li v-for="(link, index) of subnav" :key="'nav-mobile-' + index" class="mob subnav" :class="[index+1 == subnav.length ? 'subnav-last' : '']">
            <details v-if="!!link.label" class="dropdown">
              <summary>
                <a v-if="!!link.label" :href="link.url" :class="{ 'pointer-events-none': link.children.length }">
                  <span class="flex"><img v-if="link.image" :src="link.image" alt="" class="down-arrow" /> {{ link.label }} <img v-if="link.children.length" src="/images/down.svg" alt="" class="down-arrow" /></span>
                </a>
              </summary>
              <div class="dropdown-menu">
                <a v-for="(child, index) in link.children" :key="index" :href="child.url">
                  {{ child.label }} {{subnav.lengh}}
                </a>
              </div>
            </details>
          </li>
        </ul>
        <hr class="sub-nav-line" />
        <ul class="top mainnav">

          <li key="vehicle" class="desktop">
            <a class="dropdown vdropmenu"  @mouseover="vehiclesOpen=true"  @mouseleave="vehiclesOpen=false">
              <span :class="{'flex':true,'hover':vehiclesOpen }">Vehicles <img src="/images/down.svg" alt="" /></span>
              <div class="dropdown-menu">
                <a :href="vehicle.url" v-for="(vehicle, index) in vehicles" :key="index">{{ vehicle.title }}</a>
              </div>
            </a>
          </li>

          <li v-for="(link, index) of nav" :key="'desktop-' + index" class="desktop">
            <a :href="link.url" v-if="!!link.label" class="dropdown">
              <span class="flex">{{ link.label }} <img v-if="link.children.length" src="/images/down.svg" alt="" /></span>
              <div v-if="link" class="dropdown-menu">
                <a v-for="(child, index) in link.children" :key="index" :href="child.url">
                  {{ child.label }}
                </a>
              </div>
            </a>

            <a v-else :href="link.url" :class="{ selected: link.url == currentPath }">
              {{ link.label }}
            </a>
          </li>
          <!-- subnav
          <li v-for="(link, index) of subnav" :key="'nav-mobile-' + index" class="mob subnav" :class="[index+1 == subnav.length ? 'subnav-last' : '']">
            <details v-if="!!link.label" class="dropdown">
              <summary>
                <a v-if="!!link.label" :href="link.url" :class="{ 'pointer-events-none': link.children.length }">
                  <span class="flex"><img v-if="link.image" :src="link.image" alt="" class="down-arrow" /> {{ link.label }} <img v-if="link.children.length" src="/images/down.svg" alt="" class="down-arrow" /></span>
                </a>
              </summary>
              <div class="dropdown-menu">
                <a v-for="(child, index) in link.children" :key="index" :href="child.url">
                  {{ child.label }} {{subnav.lengh}}
                </a>
              </div>
            </details>
          </li> -->
          <!-- nav -->
          <li v-for="(link, index) of nav" :key="'mobile-' + index" class="mob">
            <details v-if="!!link.label" class="dropdown">
              <summary>
                <a v-if="!!link.label" :href="link.url" :class="{ 'pointer-events-none': link.children.length }">
                  <span class="flex">{{ link.label }} <img v-if="link.children.length" src="/images/down.svg" alt="" class="down-arrow" /></span>
                </a>
              </summary>
              <div class="dropdown-menu">
                <a v-for="(child, index) in link.children" :key="index" :href="child.url">
                  {{ child.label }}
                </a>
              </div>
            </details>
          </li>
        </ul>
      </nav>

      <div class="right">

        <button
          class="vdd-btn"
          @click="vehicleOpenMenuClose"
          :class="[{ 'vehicles-open': vehiclesOpen }]"
        >
          VEHICLES<img src="/images/down.svg" alt="" />
        </button>

        <button class="hamburger" @click="openMenu">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      <a v-if="button.link" :href="button.link" class="border-white button small desktop">
        {{ button.text }}
      </a>
    </div>

    <!-- <div class="vehicles-dropdown" v-show="vehiclesOpen" @mouseover="vehiclesOpen=true"  @mouseleave="vehiclesOpen=false">
      <div class="content-max-width flex flex-row flex-wrap gap-2.5 lg:gap-5">
        <article v-for="vehicle in vehicles">
          <a :href="vehicle.url">
          <div class="img-wrap">
            <img :src="vehicle.image" :alt="vehicle.url" />
          </div>
          <div class="txt-grp">
            <span class="name">{{ vehicle.title }}</span>
            <p class="motto">{{ vehicle.subtitle }}</p>
          </div>
        </a>
        </article>
      </div>
    </div> -->
    <div class="vehicles-new-dropdown" v-show="vehiclesOpen" @mouseover="vehiclesOpen=true"  @mouseleave="vehiclesOpen=false">
      <div class="flex content-max-width ">
        <div class="sidebar">
          <a :href="link.url" v-for="(link, index) in vehiclesNav" :key="index">
            <img :src="link.image" :alt="link.label">{{ link.label }}</a>
          <!-- <a href="/request-a-quote"><img src="/images/request-quote.svg" alt="Request a quote" class="quote">REQUEST A QUOTE</a>
          <a href="/current-offers"><img src="/images/current-offers.svg" alt="Current offers" class="offer">CURRENT OFFERS</a> -->
        </div>

        <div class="flex flex-col vehicle-list-ctr">
          <!-- Electric -->
          <div v-if="vehicledropdown[0].electric.data && vehicledropdown[0].electric.data.length > 0" class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 vehicle-list">
            <div class="vehicle-type">{{vehicledropdown[0].electric.title}}</div>

            <article v-for="(vehicle, index) in vehicledropdown[0].electric.data" :key="index">
              <a :href="vehicle.redirect_url ? vehicle.redirect_url : vehicle.url">
                <div class="img-wrap">
                  <img :src="vehicle.image" alt="">
                </div>
              </a>
              <div class="txt-grp">
                <a :href="vehicle.redirect_url ? vehicle.redirect_url : vehicle.url">
                  <p class="name">{{vehicle.title}}</p>
                </a>
                <p class="price">{{vehicle.subtitle}}</p>
                <div class="hr"></div>
                <p class="motto">{{vehicle.caption}}</p>
              </div>
            </article>
          </div>

          <!-- Hybrid -->
          <div v-if="vehicledropdown[0].hybrid.data && vehicledropdown[0].hybrid.data.length > 0" class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 vehicle-list">
            <div class="vehicle-type">{{vehicledropdown[0].hybrid.title}}</div>

            <article  v-for="(vehicle, index) in vehicledropdown[0].hybrid.data" :key="index">
              <a :href="vehicle.redirect_url ? vehicle.redirect_url : vehicle.url">
                <div class="img-wrap">
                  <img :src="vehicle.image" alt="">
                </div>
              </a>
              <div class="txt-grp">
                <a :href="vehicle.redirect_url ? vehicle.redirect_url : vehicle.url">
                  <p class="name">{{vehicle.title}}</p>
                </a>
                <p class="price">{{vehicle.subtitle}}</p>
                <div class="hr"></div>
                <p class="motto">{{vehicle.caption}}</p>
              </div>

            </article>
        </div>

        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    menu: {
      type: Array,
      required: true,
    },
    submenu: {
      type: Array,
      required: true,
    },
    vehicledropdown: {
      type: Array|Object,
      default: []
    },
    vehicles: {
      type: Array,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    button: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isOpen: false,
      vehiclesOpen: false,
      vehiclesNav: [],
      nav: [],
      subnav : [],
    }
  },

  mounted() {
    // console.log('v-drop',this.vehicledropdown)
    this.nav = this.menu.filter(item => item.label !== "Vehicles");
    this.subnav = this.submenu.filter(item => item.label !== "Vehicles");
    this.vehiclesNav = this.menu
        .filter(item => item.label === "Vehicles")
        .map(item => item.children)
        .flat();

    // console.log('subnav', this.subnav, this.nav)
  },

  methods: {
    vehicleOpenMenuClose() {
      if (this.isOpen === true) {
        this.vehiclesOpen = !this.vehiclesOpen;
        this.isOpen = !this.isOpen;
      } else {
        this.vehiclesOpen = !this.vehiclesOpen;
      }
    },
    openMenu() {
      if(this.vehiclesOpen === true) {
        this.isOpen = !this.isOpen;
        this.vehiclesOpen = !this.vehiclesOpen;
      } else {
        this.isOpen = !this.isOpen;
      }


    }
  },

  computed: {
    currentPath() {
      return window.location.pathname
    },
    isHome() {
      return ['/home', '/atto-3', '/'].includes(this.currentPath)
    },
  },
}
</script>

<style>
details > summary {
  list-style: none;
}
details > summary::-webkit-details-marker {
  display: none;
}
details[open] .down-arrow {
  transform: rotate(180deg);
}
</style>
